interface SearchScopePillProps {
  label: string;
  onDismiss: () => void;
}

export const SearchScopePill = ({ label, onDismiss }: SearchScopePillProps) => {
  return (
    <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-gray-300 bg-gray-50 text-sm text-gray-700">
      <svg
        className="w-4 h-4 text-gray-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
        />
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
      <span>{label}</span>
      <button
        type="button"
        onClick={onDismiss}
        className="ml-1 text-gray-400 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-info-500 rounded"
        aria-label={`Clear scope: ${label}`}
      >
        <svg
          className="w-3 h-3"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2.5}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
};
